import { Flex } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { CommandOption } from '../../types/commandTypes'

interface Props {
  option: CommandOption
}

/**
 * One filter option row: a localized label. Shared by the composer's filter.
 */
export const FilterOptionLabel: React.FC<Props> = ({ option }) => {
  const { t } = useTranslation()

  const label = option.icon
    ? t(`countries.${option.icon}` as never, { defaultValue: option.name || option.description })
    : option.name || option.description

  return (
    <Flex alignItems='center' gap={2}>
      {label}
    </Flex>
  )
}
